module.exports = __webpack_public_path__ + "static/media/recipe_category_18.f8c2146d.png";